import { call, put, takeEvery } from 'redux-saga/effects';
import { message } from 'antd';
import { productCategoriesAPI } from '../../api/config';
import * as types from '../constants/actionTypes';
import * as actions from '../actions/productCategoryActions';

// Fetch All Product Categories Saga
function* fetchProductCategoriesSaga(action) {
  try {
    const response = yield call(productCategoriesAPI.fetchProductCategories, action.payload.filters);
    const { product_categories, total_count } = response.data;
    
    yield put(actions.fetchProductCategoriesSuccess(product_categories, total_count));
  } catch (error) {
    const errorMessage = error.response?.data?.message || 'Failed to fetch product categories';
    yield put(actions.fetchProductCategoriesFailure(errorMessage));
    message.error(errorMessage);
  }
}

// Fetch Active Product Categories Saga
function* fetchActiveProductCategoriesSaga(action) {
  try {
    const response = yield call(productCategoriesAPI.fetchActiveProductCategories);
    const { product_categories, total_count } = response.data;
    
    yield put(actions.fetchActiveProductCategoriesSuccess(product_categories, total_count));
  } catch (error) {
    const errorMessage = error.response?.data?.message || 'Failed to fetch active product categories';
    yield put(actions.fetchActiveProductCategoriesFailure(errorMessage));
    message.error(errorMessage);
  }
}

// Get Product Category by ID Saga
function* getProductCategorySaga(action) {
  try {
    const { id } = action.payload;
    const response = yield call(productCategoriesAPI.getProductCategory, id);
    const { product_category } = response.data;
    
    yield put(actions.getProductCategorySuccess(product_category));
  } catch (error) {
    const errorMessage = error.response?.data?.message || 'Failed to fetch product category';
    yield put(actions.getProductCategoryFailure(errorMessage));
    message.error(errorMessage);
  }
}

// Create Product Category Saga
function* createProductCategorySaga(action) {
  try {
    const response = yield call(productCategoriesAPI.createProductCategory, action.payload.categoryData);
    const { product_category } = response.data;
    
    yield put(actions.createProductCategorySuccess(product_category));
    message.success('Product category created successfully');
    
    // Refresh the list
    yield put(actions.fetchProductCategoriesRequest({}));
  } catch (error) {
    const errorMessage = error.response?.data?.message || 'Failed to create product category';
    yield put(actions.createProductCategoryFailure(errorMessage));
    message.error(errorMessage);
  }
}

// Update Product Category Saga
function* updateProductCategorySaga(action) {
  try {
    const { id, categoryData } = action.payload;
    const response = yield call(productCategoriesAPI.updateProductCategory, id, categoryData);
    const { product_category } = response.data;
    
    yield put(actions.updateProductCategorySuccess(product_category));
    message.success('Product category updated successfully');
    
    // Refresh the list
    yield put(actions.fetchProductCategoriesRequest({}));
  } catch (error) {
    const errorMessage = error.response?.data?.message || 'Failed to update product category';
    yield put(actions.updateProductCategoryFailure(errorMessage));
    message.error(errorMessage);
  }
}

// Root Product Category Saga
export default function* productCategorySaga() {
  yield takeEvery(types.FETCH_PRODUCT_CATEGORIES_REQUEST, fetchProductCategoriesSaga);
  yield takeEvery(types.FETCH_ACTIVE_PRODUCT_CATEGORIES_REQUEST, fetchActiveProductCategoriesSaga);
  yield takeEvery(types.GET_PRODUCT_CATEGORY_REQUEST, getProductCategorySaga);
  yield takeEvery(types.CREATE_PRODUCT_CATEGORY_REQUEST, createProductCategorySaga);
  yield takeEvery(types.UPDATE_PRODUCT_CATEGORY_REQUEST, updateProductCategorySaga);
}